import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  imports: [FormsModule],
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextEditorComponent),
      multi: true,
    },
  ],
})
export class TextEditorComponent implements ControlValueAccessor {
  @ViewChild('editor')
  set editor(editor: ElementRef<HTMLDivElement>) {
    if (editor && !this._editor) {
      import('quill').then((q) => {
        this._editor = new q.default(editor.nativeElement, {
          theme: 'snow',
          placeholder: '',
          modules: {
            toolbar: [
              [{ size: ['small', false, 'large', 'huge'] }],
              ['bold', 'italic', 'underline', 'strike'],
              ['link'],
              [{ align: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
            ],
          },
        });

        this._editor.root.innerHTML = this._value ?? '';

        this._editor.on('text-change', () => this.onChange(this._editor.root.innerHTML));
      });
    }
  }

  @Input({ required: true }) name: string;
  @Input() height: number;
  onChange = (_) => {};
  onTouched = () => {};

  protected _value: string;
  protected _disabled: boolean;
  _editor: any;

  writeValue(value: string): void {
    this._value = value;
    if (this._editor) {
      this._editor.root.innerHTML = value;
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onBlur(): void {
    this.onTouched();
  }

  contentChange(event: any): void {
    const html = event.html;
    this.onChange(html.replace(/&nbsp;/g, ' '));
  }
}
